// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2TpPH","content":"RecentSearches_content__1tacv"};